import type { EventYear, Location } from '../types';

/** Resolve a location id within a specific event's location set. */
export function getLocationById(
  event: EventYear,
  id: string,
): Location | undefined {
  return event.locations.find((location) => location.id === id);
}
